import React from 'react'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type ResizeLayoutDialogProps = {
  open: boolean
  onCancel: () => void
  onResize: () => void
}

const ResizeLayoutDialog: React.FC<ResizeLayoutDialogProps> = ({ open, onCancel, onResize }) => {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onCancel()}>
      <DialogContent
        showCloseButton={false}
        className="w-[560px] max-w-[calc(100%-2rem)] rounded-[18px] border border-[var(--base-border,#E5E5E5)] bg-[var(--base-background,#FFF)] px-7 pt-7 pb-6 shadow-xl"
      >
        <DialogHeader className="gap-0 pr-10 text-left">
          <DialogTitle className="text-[18px] leading-[24px] font-semibold text-[var(--base-foreground,#0A0A0A)]">
            Resize layout
          </DialogTitle>
          <DialogDescription className="pt-10 text-[16px] leading-7 text-[var(--base-foreground,#0A0A0A)]">
            Resize columns and rows to fit the new page.
          </DialogDescription>
        </DialogHeader>
        <DialogClose
          onClick={onCancel}
          className="absolute top-6 right-6 rounded-[2px] p-0 text-[var(--base-muted-foreground,#737373)] opacity-70 transition-colors hover:bg-accent hover:text-[var(--base-foreground,#0A0A0A)]"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
        <DialogFooter className="pt-8 sm:justify-end">
          <div className="flex items-center justify-end gap-3">
            <Button
              variant="outline"
              onClick={onCancel}
              className="h-11 rounded-xl border border-[var(--base-border,#E5E5E5)] bg-[var(--base-background,#FFF)] px-5 text-[16px] font-medium text-[var(--base-foreground,#0A0A0A)] shadow-xs hover:bg-accent hover:text-accent-foreground"
            >
              Cancel
            </Button>
            <Button
              onClick={onResize}
              className="h-11 rounded-xl bg-[var(--base-primary,#144087)] px-5 text-[16px] font-medium text-[var(--base-primary-foreground,#FAFAFA)] shadow-xs hover:bg-[var(--base-primary,#144087)]/90"
            >
              Resize
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ResizeLayoutDialog
